"use client";

import React from "react";
import SidebarLayout from "./SidebarLayout";

interface AboutLayoutProps {
    children: React.ReactNode;
}

const AboutLayout: React.FC<AboutLayoutProps> = ({ children }) => {
    return (
        <SidebarLayout navTitle="About" sidebarHeader="About Us">
            {children}
        </SidebarLayout>
    );
};

export default AboutLayout;

